import styled from 'styled-components';

const ButtonLink = styled.button`
  background: none !important;
  border: none;
  padding: 2px 1px 0;
  text-decoration: underline;
  color: blue;
  cursor: pointer;
  font-size: .9rem;
  display: inline;
  text-align: left;
`;

export default {
  ButtonLink,
};
